import type { Reducer } from '@reduxjs/toolkit'

let inject: ((key: string, reducer: Reducer) => void) | null = null
export function configureReducerInjector(injector: (key: string, reducer: Reducer) => void): void { inject = injector }
export function injectFeatureReducer(key: string, reducer: Reducer): void {
  if (!inject) throw new Error('Feature reducer injector has not been configured.')
  inject(key, reducer)
}
